export default "__VITE_ASSET__28d7dcf4__"